import { colors } from "styles/constants/colors";
import { getSubjectInBahasa } from "utils/utils";
import { ISubjectTagData } from "./subject-tag.types";

const SubjectTagData: ISubjectTagData = {
  MATHS: {
    text: getSubjectInBahasa("maths"),
    iconSrc: "/assets/subjects/mtk.svg",
    backgroundColor: colors.brand[100],
    color: colors.brand[500]
  },
  PHYSICS: {
    text: getSubjectInBahasa("physics"),
    iconSrc: "/assets/subjects/physics.svg",
    backgroundColor: colors.pink[100],
    color: colors.magenta[600]
  },
  CHEMISTRY: {
    text: getSubjectInBahasa("chemistry"),
    iconSrc: "/assets/subjects/chemistry.svg",
    backgroundColor: colors.orange[100],
    color: colors.tango[500]
  },
  "BAHASA INGGRIS": {
    text: "Bahasa Inggris",
    iconSrc: "/assets/subjects/bahasa-inggris.svg",
    backgroundColor: colors.green[50],
    color: colors.green[800]
  },
  "EKSKLUSIF COLEARN+": {
    text: "Eksklusif CoLearn+",
    iconSrc: "/assets/subjects/colearn-plus.svg",
    backgroundColor: colors.navy[1000],
    color: colors.navy[500]
  },
  FISIKA: {
    text: "Fisika",
    iconSrc: "/assets/subjects/fisika.svg",
    backgroundColor: colors.pink[100],
    color: colors.magenta[600]
  },
  IPA: {
    text: "IPA",
    iconSrc: "/assets/subjects/ipa.svg",
    backgroundColor: colors.aqua[50],
    color: colors.aqua[600]
  },
  KIMIA: {
    text: "Kimia",
    iconSrc: "/assets/subjects/kimia.svg",
    backgroundColor: "#FFF3E0",
    color: "#EF6C00"
  },
  MATEMATIKA: {
    text: "Matematika",
    iconSrc: "/assets/subjects/matematika.svg",
    backgroundColor: colors.brand[50],
    color: colors.brand[500]
  },
  "MATEMATIKA (WAJIB+MINAT)": {
    text: "Matematika (Wajib+Minat)",
    iconSrc: "/assets/subjects/matematika.svg",
    backgroundColor: colors.brand[50],
    color: colors.brand[500]
  },
  "MATEMATIKA LANJUT": {
    text: "Matematika Lanjut",
    iconSrc: "/assets/subjects/matematika.svg",
    backgroundColor: colors.brand[50],
    color: colors.brand[500]
  },
  "MATEMATIKA WAJIB": {
    text: "Matematika Wajib",
    iconSrc: "/assets/subjects/matematika.svg",
    backgroundColor: colors.brand[50],
    color: colors.brand[500]
  },
  UTBK: {
    text: "UTBK",
    iconSrc: "/assets/subjects/utbk.svg",
    backgroundColor: "#F9E6E6",
    color: "#A92828"
  }
};

export { SubjectTagData };
